<template>
  <div id="tagObjectBrowse" class="h-full" v-loading="loading">
    <el-card style="height: 100%" :body-style="{ padding: '10px', height: '100%' }">
      <div class="h-full">
        <div class="mb-10px">
          <DynamicIframe
            :pages="pages"
            :data="dataToDynamic"
            :tagId="detailsList.id || null"
            :tagCode="detailsList.code || null"
            v-if="this.currentEnv.dynamicMenu"
            ref="DynamicIframe"
          ></DynamicIframe>
        </div>
        <div class="object-info">
          <el-row type="flex" :gutter="20" v-show="!isFullShow">
            <el-col :span="12">
              <el-tabs type="border-card" v-model="baseInfoTabs" class="object-tabs">
                <el-tab-pane name="one" :label="$t('basicInformation')">
                  <div class="panel-inner">
                    <el-form label-width="80px">
                      <el-form-item :label="$t('namespace')">
                        <el-input :value="baseInfo.namespace" readonly></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('category')">
                        <el-input :value="baseType ? baseType.name : ''" readonly></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('code')">
                        <el-input :value="baseInfo.code" readonly></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('name')">
                        <el-input :value="baseInfo ? baseInfo.name : ''" readonly></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('shortDescription')">
                        <el-input
                          type="textarea"
                          :value="baseInfo.shortDescription"
                          readonly
                        ></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('longDescription')">
                        <el-input
                          type="textarea"
                          :value="baseInfo.longDescription"
                          readonly
                        ></el-input>
                      </el-form-item>
                    </el-form>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="two" :label="$t('associationProperties')" class="h-full">
                  <el-table
                    :data="attributeList"
                    border
                    :highlight-current-row="true"
                    :header-cell-style="{ textAlign: 'center' }"
                    :cell-style="{ textAlign: 'center' }"
                    stripe
                    height="228"
                  >
                    <el-table-column
                      type="index"
                      width="65"
                      :label="`${$t('seqNo')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="name"
                      :label="`${$t('classAttrName')}`"
                    ></el-table-column>
                    <el-table-column
                      prop="code"
                      :label="`${$t('classAttrCode')}`"
                    ></el-table-column>
                    <el-table-column :label="`${$t('classAttrValue')}`">
                      <template slot-scope="scope">
                        <span>{{ scope.row.value }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane name="three" :label="$t('associativeTags')">
                  <div class="panel-inner">
                    <el-tree
                      :highlight-current="true"
                      :data="numTree"
                      :props="defaultPropsTag"
                      accordion
                      @node-click="clickTagNode"
                    ></el-tree>
                  </div>
                </el-tab-pane>
                <el-tab-pane name="four" :label="$t('associateDocuments')">
                  <div class="panel-inner">
                    <div
                      v-if="!(documentTree && documentTree.length)"
                      class="text-center p-10px c-g9"
                    >
                      暂无数据
                    </div>
                    <el-tree
                      v-if="documentTree && documentTree.length"
                      :highlight-current="true"
                      :data="documentTree"
                      :props="defaultPropsDocument"
                      accordion
                      @node-click="clickDocNode"
                    >
                      <div
                        class="text-overflow w-full d-flex flex-row-between"
                        slot-scope="{ node, data }"
                      >
                        <el-tooltip
                          :open-delay="1000"
                          :content="`${node.label}${data.code ? `[${data.code}]` : ''}`"
                          placement="top"
                        >
                          <span
                            class="ell doc-tree-lable text-14px"
                            style="line-height: 36px; height: 36px"
                            >{{ node.label }}</span
                          >
                        </el-tooltip>
                        <el-tooltip
                          :open-delay="1000"
                          content="文档浏览"
                          placement="top"
                          v-if="data.documentId"
                        >
                          <el-button type="primary" class="mr-10px" @click.stop="viewDocment(data)"
                            ><i class="iconfont icon-line-show"></i
                          ></el-button>
                        </el-tooltip>
                      </div>
                    </el-tree>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-col>
            <el-col :span="12">
              <div
                class="mb-10px c-g9 text-center primary-border"
                v-if="!timeData.length"
                style="
                  border: 1px solid #dcdfe6;
                  height: 301px;
                  line-height: 301px;
                  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
                  height: 320px;
                "
              >
                暂无数据
              </div>
              <div
                class="primary-border"
                v-if="timeData.length"
                style="
                  border: 1px solid #dcdfe6;
                  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
                  padding: 10px;
                "
              >
                <!--<div id="timeLine" class="mb-10px" v-if="tagId"></div>-->
                <div id="visualization" class="mb-10px" v-if="tagId">
                  <div class="menu time-line-menu mb-5px">
                    <span>{{ $t('changeHistory') }}</span>
                  </div>
                </div>
                <el-table :data="historyData" height="140" border stripe>
                  <el-table-column prop="property" :label="$t('changes')"></el-table-column>
                  <el-table-column
                    prop="beforeData"
                    :label="$t('beforeTheChange')"
                  ></el-table-column>
                  <el-table-column prop="afterData" :label="$t('afterTheChange')"></el-table-column>
                </el-table>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="time-line-box mt-10px" style="height: calc(100% - 330px)">
          <el-row type="flex" :gutter="20" class="h-full">
            <el-col :span="modelWidth" class="h-full">
              <el-card
                class="h-full"
                :class="[!isFullShow ? '' : 'model-card']"
                v-if="tagId"
                :body-style="{ height: 'calc(100% - 45px)' }"
              >
                <div slot="header" class="clearfix">
                  <span>{{ $t('documentBrowsing') }}</span>
                  <el-button
                    class="float-right i-fullScreen"
                    style="color: #333333"
                    type="text"
                    icon="iconfont icon-line-fullScreen"
                    size="mini"
                    @click="showModelScreen"
                  ></el-button>
                </div>
                <div id="iframeW" class="dib w-full pos-rel h-full" style="overflow-y: auto">
                  <div class="text-center p-10px c-g9 iframe-h" v-if="imgSrc === '文件不存在'">
                    文件不存在
                  </div>
                  <div v-else style="height: 100%">
                    <div v-if="modelCenterVersion === 'v1'" class="h-full">
                      <div id="container" style="height: 100%" v-show="type === '.pr'"></div>
                      <div v-show="type !== '.pr'" style="height: 100%">
                        <div
                          class="iframe-h"
                          v-if="imgSrc && (type === '.png' || type === '.jpg' || type === '.tif')"
                        >
                          <div class="focal iframe-h" v-if="!isPanorama">
                            <div class="panzoom iframe-h">
                              <img
                                id="imgAction"
                                :src="imgSrc"
                                v-if="imgSrc"
                                alt=""
                                class="w-full h-full cover db"
                              />
                            </div>
                          </div>
                        </div>
                        <div v-else-if="type === '.mp4'">
                          <div v-if="videoLoading" class="p-20 text-center" style="height: 92vh">
                            <i class="iconfont icon-spinner has-text-info"></i>
                          </div>
                          <div v-if="!videoLoading">
                            <div v-if="!videoError" class="show-video">
                              <video-player
                                class="video-player vjs-custom-skin"
                                ref="videoPlayer"
                                :options="playerOptions"
                                :playsinline="true"
                                @ready="playerReadied($event)"
                              >
                              </video-player>
                            </div>
                            <div
                              class="text-center p-10px c-g9"
                              style="height: 92vh"
                              v-show="videoError"
                            >
                              视频播放出现错误
                            </div>
                            <!--</el-card>-->
                          </div>
                        </div>
                        <!-- <div
                        id="svgIframe"
                        v-else-if="type === '.svg' && scaleReload"
                        style="position:absolute;left:0;right:0;top:0;bottom:37px;background:#000"
                      ></div> -->
                        <iframe
                          v-loading="scaleReload"
                          :class="{ 'bg-color-white': type === '.svg' }"
                          class="w-full h-full"
                          id="svgIframe"
                          @load="scaleReload = false"
                          :src="`/lib/svgView/index.html?file=${imgSrc}`"
                          v-else-if="type === '.svg'"
                        ></iframe>
                        <iframe
                          id="pdfIframe"
                          ref="svgIframe"
                          :src="imgSrc"
                          v-else-if="type === '.pdf'"
                          style="height: 100%; width: 100%"
                        ></iframe>
                        <iframe
                          v-else-if="type === '.wizdrawing'"
                          ref="htFrame"
                          src="/static/ht/htView.html"
                          class="h-full w-full"
                        ></iframe>
                        <div class="text-center p-10px c-g9" v-else>暂无数据</div>
                      </div>
                    </div>
                    <file-view
                      ref="fileView"
                      v-else
                      class="fileView"
                      @loaded="loaded"
                      :currentBrowseFile="currentBrowseFile"
                      :standardId="standardId"
                      type="object"
                    ></file-view>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="relationWidth" class="h-full">
              <el-card
                :class="[!isFullShow ? 'object-card' : 'screen-card']"
                v-if="tagId"
                :body-style="{ height: 'calc(100% - 45px)' }"
                class="h-full"
              >
                <div slot="header" class="clearfix">
                  <span>{{ $t('associativeRelationships') }}</span>
                  <el-button
                    class="float-right i-fullScreen"
                    style="color: #333333"
                    type="text"
                    icon="iconfont icon-line-fullScreen"
                    size="mini"
                    @click="showRelationScreen"
                  ></el-button>
                </div>
                <div id="tabNetwork" v-if="this.tagId"></div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="text-center c-g9 text-16px">暂无数据</div>
    </el-card>
  </div>
</template>

<script>
import screenfull from 'screenfull'
import ApiMixins from '@/assets/js/api'
import ApiMixinTagObjectBrowse from '@/assets/js/api/tagObjectBrowse'
import ApiMixinCable from '@/assets/js/api/cableManagement'
import DynamicIframe from '@/components/dynamicIframe'
import apiCustomerMenu from '@/assets/js/api/customerMenu'
import panzoom from 'jquery.panzoom'
import $ from 'jquery'
import { videoPlayer } from 'vue-video-player'
import vis from 'vis'
import { load } from '@/assets/js/svg.js'
import DocumentService from '@/services/DocumentService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import fileView from '../docView/components/fileView'

export default {
  name: 'tagObjectBrowse',
  components: {
    videoPlayer,
    DynamicIframe,
    fileView,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        loop: true,
        freeMode: true,
      },
      activeSwitch: true,
      swiperSlides: [1, 2],
      isPanorama: false,
      pages: null,
      detailsList: {},
      baseInfoTabs: 'one',
      relationTabs: 'base',
      isFullShow: false,
      timeItems: null,
      historyData: [],
      timeData: [],
      tagId: '',
      baseInfo: {}, // 基本信息
      baseType: {},
      relationCommonAttr: [], // 关联属性(通用属性)
      attributeTemplate: {},
      relationOtherAttr: [], // 关联属性(其他属性)
      numTree: [], // 关联位号
      documentTree: [], // 关联文档树
      defaultPropsTag: {
        label: (data) => {
          if (data.nodeCode) {
            return `${data.nodeCode}[${data.nodeName}]`
          }
          return data.nodeName
        },
        children: 'childrenNodes',
      },
      defaultPropsDocument: {
        label: (data) => {
          if (data.documentName) {
            return `${data.nodeName}[${data.documentName}]`
          }
          return data.nodeName
        },
        children: 'childrenNodes',
      },
      SubDataProp: { label: 'fileName', children: 'dirs' },
      imgSrc: null, // 图片的路径
      modelSrc: null,
      type: '.pr', // 文件的类型
      fileValue: '', // 默认文件的值
      tagCode: '',
      modalActive: false,
      screenfullShow: false,
      iframeShown: '',
      playerOptions: {
        height: '700',
        muted: false,
        preload: 'auto',
        aspectRatio: '16:9',
        language: 'zh-CN',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'video/mp4',
            src: '',
          },
        ],
        fluid: true,
        poster: '',
      },
      videoLoading: false,
      videoError: false,
      modelLoad: true,
      iframeWidth: 0,
      modelWidth: 12,
      relationWidth: 12,
      isScreen: false,
      loading: false,
      nodes: null,
      edges: null,
      oldEdges: [],
      drawTime: false,
      player: null,
      modelAlreadyLoaded: null,
      currentSelectedFileId: null,
      centerToSelectImmediately: null,
      oldRouteParams: '',
      timeLine: null,
      wizplayerOption: null,
      scaleReload: false,
      tagNodes: [],
      loadedEnd: false, // 模型加载完毕
      attributeList: [],
      currentBrowseFile: {}, // 传给标记的参数
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
    pixelCullingThres() {
      const obj = _.find(this.systemParams, { parameterCode: 'pixelCullingThres' })
      return obj ? obj.parameterValue * 1 : 5
    },
    dataToDynamic() {
      return {
        from: 'tag',
        templateAttrSetList: this.relationOtherAttr,
        ...this.baseInfo,
      }
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    playerServer() {
      const playerServer = _.find(this.systemParams, { parameterCode: 'playerServer' })
      return playerServer ? playerServer.parameterValue : null
    },
    playerServerProtocol() {
      const playerServerPro = _.find(this.systemParams, { parameterCode: 'playerServerProtocol' })
      return playerServerPro ? playerServerPro.parameterValue : null
    },
    playerBtnVisible() {
      const playerOption = _.find(this.systemParams, { parameterCode: 'wizplayerButtonVisible' })
      return playerOption ? JSON.parse(playerOption.parameterValue) : {}
    },
    modelCenterVersion() {
      const version = _.find(this.systemParams, { parameterCode: 'modelCenterVersion' }) || {}
      return version.parameterValue
    },
    standardId() {
      return this.$route.query.standardId
    },
    classId() {
      return this.$route.query.classId
    },
  },
  watch: {
    imgSrc(url) {
      if (this.type === '.svg' && url) {
        this.scaleReload = true
      }
    },
    async $route(to) {
      if (_.includes(to.path, '/assetsBrowse/tagObjectBrowse')) {
        this.type = null
        this.tagId = ''
        this.baseInfo = {}
        this.baseType = {}
        this.isFullShow = false
        this.modelWidth = 12
        this.relationWidth = 12
        this.isScreen = false
        this.relationCommonAttr = []
        this.attributeTemplate = {}
        this.relationOtherAttr = []
        this.documentTree = []
        this.baseInfoTabs = 'one'
        this.timeData = []
        this.timeLine = null
        this.historyData = []
        this.nodes = null
        this.edges = null
        screenfull.off('change')
        this.imgSrc = null
        this.modelSrc = null
        if (this.player) {
          this.player.destroy()
          this.player = null
        }
        await this.getTagId()
        await this.initTimeLine()
        await this.initConnect()
        await this.initBaseInfo()
        await this.numTreeData()
        await this.documentTreeData()
      }
    },
    // 监听模型加载完毕
    loadedEnd(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.fileView.progressCodeByItem.hasOwnProperty(this.baseInfo.code)) {
            this.$refs.fileView.code = this.baseInfo.code
          } else {
            this.$message.warning('当前模型没有对应code')
          }
        })
      }
    },
  },
  methods: {
    // 获取模板属性
    async getTemplateAttribute() {
      if (!this.$route.query.classId) return
      const parameter = {
        classId: this.$route.query.classId, // 类别id
      }
      const res = await stdClassDataService.getInsertData(parameter)
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data.attributeList
        this.attributeList.forEach((item) => {
          if (item.refrenceAttributeId) {
            this.$set(item, 'transitList', [])
          }
        })
      }
    },
    // ht加载
    htLoad(url) {
      try {
        this.$refs.htFrame.contentWindow.init(url)
      } catch (error) {
        setTimeout(() => {
          this.htLoad(url)
        }, 500)
        return
      }
      const $window = this.$refs.htFrame.contentWindow
      if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'GZ') {
        setTimeout(() => {
          $window.setColorChange()
        }, 500)
        this.htTimer = setInterval(() => {
          $window.setColorChange()
        }, 8000)
      }
    },
    // 获取位号id
    async getTagId() {
      this.tagId = this.$route.params.id || this.$route.query.id
      if (!this.tagId) {
        this.$router.go(-1)
      }
    },
    // 初始化基本信息
    async initBaseInfo() {
      if (this.tagId) {
        const res = await this.apiTags({
          method: 'list',
          params: {
            tagId: this.tagId,
            pageIndex: 1,
            pageSize: 10,
            standardId: this.standardId,
          },
        })
        if (res && res.code === 0 && res.data) {
          this.baseInfo = res.data.tag
          this.baseType = res.data.classAndAttributes ? res.data.classAndAttributes.classInfo : null
          const attributes =
            res.data.classAndAttributes && res.data.classAndAttributes.attributes
              ? res.data.classAndAttributes.attributes
              : []
          if (attributes.length > 0) {
            _.map(this.attributeList, (item, index) => {
              _.map(attributes, (aItem) => {
                if (item.stdClassAttributeId === aItem.attrId) {
                  this.$set(this.attributeList[index], 'value', aItem.attrValue)
                }
              })
            })
          }
        }
      }
    },
    // 获取关联位号树的数据
    async numTreeData() {
      if (this.tagId) {
        const res = await this.apiTags({
          method: 'docRelationTag',
          params: {
            tagId: this.tagId,
          },
        })
        if (res && res.data && res.code === 0) {
          this.numTree = res.data
        }
      }
    },
    // 获取关联文档树的数据
    async documentTreeData() {
      if (this.tagId) {
        const res = await this.apiTags({
          method: 'docRelationFile',
          params: {
            tagId: this.tagId,
          },
        })
        if (res && res.data && res.code === 0) {
          this.documentTree = res.data
        }
      }
    },
    // 初始化时间轴
    async initTimeLine() {
      this.timeLine = null
      this.timeItems = new vis.DataSet([])
      const res = await this.apiTags({
        method: 'time',
        params: { tagId: this.tagId },
      })
      if (res && res.code === 0 && !_.isEmpty(res.data)) {
        this.timeData = []
        _(res.data).forEach((item) => {
          this.timeData.push({
            id: `${item.batchNo},${item.status}`,
            content: `
              <p class="circle-span span-info iconfont icon-bg-circleWarning text-red-500 text-20px">
                <p>${moment(item.createdTime).format('YYYY-MM-DD HH:mm:ss')}</p>
              </p>
            `,
            start: moment(item.createdTime).format('YYYY-MM-DD HH:mm:ss'),
          })
        })
        this.$nextTick(() => {
          this.timeItems = new vis.DataSet(this.timeData)
          const container = document.getElementById('visualization')
          const options = {
            editable: false,
            height: '118px',
            verticalScroll: true,
            showMinorLabels: false,
            showMajorLabels: false,
          }
          this.timeLine = new vis.Timeline(container, this.timeItems, options)
          this.timeLine.on('select', async (data) => {
            if (
              data.items.length &&
              data.event.target.className ===
                'circle-span span-info iconfont icon-bg-circleWarning text-red-500 text-20px'
            ) {
              const result = await this.apiTags({
                method: 'diff',
                params: {
                  tagId: this.tagId,
                  batchNo: data.items[0].split(',')[0],
                  compareMethod: data.items[0].split(',')[1],
                },
              })
              if (result && result.data && result.code === 0) {
                this.historyData = result.data
              }
              const arr = _.toArray(document.getElementsByClassName('circle-span'))
              _.forEach([...arr], (item) => {
                item.className =
                  'circle-span span-info iconfont icon-bg-circleWarning text-red-500 text-20px'
              })
              if (
                data.event.target.className ===
                'circle-span span-info iconfont icon-bg-circleWarning text-red-500 text-20px'
              ) {
                data.event.target.className =
                  'circle-span span-check iconfont icon-line-circleComplete text-green-500 text-20px'
              }
            }
          })
        })
      }
    },
    // 关联关系
    async initConnect() {
      this.$nextTick(async () => {
        this.nodes = new vis.DataSet([])
        this.edges = new vis.DataSet([])
        const container = document.getElementById('tabNetwork')
        const data = { nodes: this.nodes, edges: this.edges }
        const options = {
          edges: {
            font: {
              size: 12,
            },
            widthConstraint: {
              maximum: 40,
            },
            length: 380,
          },
          nodes: {
            borderWidth: 0,
            color: {
              border: '#2B7CE9',
              background: '#fff',
              highlight: {
                background: '#fff',
              },
              hover: {
                background: '#fff',
              },
            },
            shapeProperties: {
              useBorderWithImage: true,
            },
          },
          physics: {
            timestep: 0.1,
            // 物理引擎-计算节点之前斥力，进行自动排列的属性
            stabilization: false,
            barnesHut: {
              centralGravity: 0.3,
              springLength: 60,
              gravitationalConstant: -40000,
              avoidOverlap: 1,
              damping: 0.09,
              springConstant: 0.5,
            },
            minVelocity: 16,
            // manipulation: { enabled: false },
            enabled: true, // 默认是true，设置为false后，节点将不会自动改变，拖动谁谁动。不影响其他的节点
          },
        }
        const res = await this.apiTags({ method: 'relation', params: { id: this.tagId } })
        if (res && res.data && res.code === 0) {
          this.tagNodes = res.data.tagNodes
          res.data.tagNodes.forEach((item) => {
            this.nodes.update({
              id: item.id,
              label: item.code,
              title: `名称：${item.label ? item.label : '数据无title'}`,
              image: `${this.currentEnv.VUE_APP_STANDARD_SERVER}${item.image}`,
              shape: `${item.image ? 'image' : ''}`,
              isNew: 0,
            })
          })
          _.forEach(res.data.edges, (item) => {
            this.edges.update({
              arrows: item.arrows,
              from: item.from,
              id: item.id,
              isnew: item.isNew,
              onewayonly: item.onewayonly,
              to: item.to,
              label: item.description ? item.description : '',
            })
          })
          // this.edges.update(res.data.edges)
          const network = new vis.Network(container, data, options)
          // type：0:tag, 1:class, 2:document, 3:documentFile
          let timer = null
          network.on('selectNode', (clickData) => {
            clearTimeout(timer)
            timer = setTimeout(async () => {
              const arr = _.filter(this.tagNodes, (item) => {
                return item.id === clickData.nodes[0]
              })
              if (arr.length && arr[0].type === 0) {
                const newData = await this.apiTags({
                  method: 'relation',
                  params: { id: clickData.nodes[0] },
                })
                const hasNodeData = this.nodes.get({ fields: ['id'] })
                if (newData.data && newData.code === 0) {
                  // this.tagNodes = _.concat(this.tagNodes, newData.data.tagNodes)
                  newData.data.tagNodes.forEach((item) => {
                    if (!_.find(hasNodeData, ['id', item.id])) {
                      this.tagNodes.push(item)
                      this.nodes.update({
                        id: item.id,
                        label: item.code,
                        title: `名称：${item.label ? item.label : '数据无title'}`,
                        image: `${this.currentEnv.VUE_APP_STANDARD_SERVER}${item.image}`,
                        shape: `${item.image ? 'image' : ''}`,
                        isNew: 0,
                      })
                    }
                  })
                  const edgesArr = this.edges.get({
                    fields: ['arrows', 'from', 'isnew', 'onewayonly', 'to'],
                  })
                  const obj = []
                  newData.data.edges.forEach((item) => {
                    obj.push({
                      arrows: item.arrows,
                      from: item.from,
                      isnew: item.isnew,
                      onewayonly: item.onewayonly,
                      to: item.to,
                      label: item.description ? item.description : '',
                    })
                  })
                  this.spliceEdges(obj, edgesArr)
                  this.edges.update(obj)
                }
              }
            }, 500)
          })
          network.on('doubleClick', async (clickData) => {
            clearTimeout(timer)
            const arr = _.filter(this.tagNodes, (item) => {
              return item.id === clickData.nodes[0]
            })
            if (!arr.length) return
            if (arr[0].type === 0) {
              this.$router.push(`${this.basePath}/assetsBrowse/tagObjectBrowse/${arr[0].id}`)
            }
            if (arr[0].type === 2 || arr[0].type === 3) {
              const obj = {
                nodeName: arr[0].label,
                conentId: arr[0].md5,
                fileId: arr[0].fileId,
                nodeType: 2,
                documentId: arr[0].documentId,
                documentNodeName: arr[0].code,
              }
              await this.clickDocNode(obj)
            }
          })
        }
      })
    },
    // 循环截取
    spliceEdges(data, value) {
      data.forEach((item, index) => {
        value.forEach((val) => {
          if (
            (item.from === val.to && item.to === val.from) ||
            (item.from === val.from && item.to === val.to)
          ) {
            data.splice(index, 1)
            this.spliceEdges(data, value)
          }
        })
      })
    },
    // 全屏查看模型
    showModelScreen() {
      // 定义svg图的类型是放大还是缩小
      // let state
      this.isFullShow = !this.isFullShow
      this.isScreen = !this.isScreen
      if (this.isScreen) {
        // state = 'big'
        this.modelWidth = 24
        this.relationWidth = 0
      } else {
        // state = 'small'
        this.modelWidth = 12
        this.relationWidth = 12
      }
      // this.scaleReload = false
      // $('svg').remove()
      // setTimeout(() => {
      //   this.scaleReload = true
      // }, 0)
      // if (this.type === '.svg' && this.imgSrc) {
      //   $('#svgIframe').load(this.imgSrc)
      //   setTimeout(() => {
      //     load('svgIframe', state)
      //   }, 500)
      // }
      if (this.type === '.svg') {
        this.scaleReload = true
        $('#svgIframe')[0].contentWindow.location.reload()
        this.scaleReload = false
      } else if (this.type === '.wizdrawing') {
        this.htLoad(this.imgSrc)
      }
    },
    showRelationScreen() {
      this.isFullShow = !this.isFullShow
      this.isScreen = !this.isScreen
      this.scaleReload = false
      if (this.isScreen) {
        this.modelWidth = 0
        this.relationWidth = 24
      } else {
        this.modelWidth = 12
        this.relationWidth = 12
      }
    },

    /**
     * 以下方法是关于模型播放的
     * 这些代码复制于numberObjectBrowse.vue里的文件来的
     */
    // 获取模型和svg的关联关系
    async interactiveFileRequest(siteIds, identifier, fileIds) {
      const tagInfoRes = await this.apiTags({
        method: 'tagIdentifierToInfo',
        params: {
          identifier,
          fileId: this.currentSelectedFileId,
        },
      })
      let tagCode = ''
      if (tagInfoRes && tagInfoRes.data) {
        tagCode = tagInfoRes.data.code
        const res = await this.apiDocBrowse({
          method: 'interactiveFile',
          params: {
            siteId: siteIds,
            tagCode,
            fileId: fileIds || ' ',
          },
        })
        if (res && res.data && res.success) {
          return res.data
        }
        return {}
      }
      return {}
    },
    async interactiveFileData(siteId, tagCode, fileId) {
      const tagData = await this.interactiveFileRequest(siteId, tagCode, fileId)
      if (tagData && tagData.tag) {
        this.detailsList = tagData.tag
        if (tagData.classInfo) {
          this.baseType.name = tagData.classInfo.name
        }
        this.relatingFiles = tagData.relatingFiles
        this.generalAttrSet = tagData.generalAttrSet
        this.templateAttrSetList = tagData.templateAttrSetList
        if (this.templateAttrSetList === null) {
          this.templateAttrSetList = []
        } else if (this.generalAttrSet === null) {
          this.generalAttrSet = {}
        }
      }
    },
    // 模型加载完成
    loaded(val) {
      if (val) {
        this.loadedEnd = val
      }
    },
    // 点击位号的列表触发与模型交互的事件
    async clickTagNode(data) {
      if (data.conentId) {
        localforage.setItem('tagParamsId', data.conentId || '')
        this.imgSrc = null
        this.modelSrc = null
        if (this.modelCenterVersion !== 'v1') {
          if (this.$refs.fileView.progressCodeByItem.hasOwnProperty(data.nodeCode)) {
            this.$refs.fileView.code = data.nodeCode
          } else if (this.loadedEnd) {
            this.$message.warning('当前模型没有对应code')
          }
        }
        this.type = null
        this.tagId = ''
        this.baseInfo = {}
        this.baseType = {}
        this.isFullShow = false
        this.modelWidth = 12
        this.relationWidth = 12
        this.isScreen = false
        this.relationCommonAttr = []
        this.attributeTemplate = {}
        this.relationOtherAttr = []
        this.documentTree = []
        this.baseInfoTabs = 'one'
        this.timeData = []
        this.timeLine = null
        this.historyData = []
        this.nodes = null
        this.edges = null
        screenfull.off('change')
        this.imgSrc = null
        this.modelSrc = null
        this.tagId = data.conentId
        await this.initTimeLine()
        await this.initConnect()
        await this.initBaseInfo()
        await this.numTreeData()
        await this.documentTreeData()
        screenfull.on('change', () => {
          this.screenfullShow = screenfull.isFullscreen
        })
        this.wizplayerOption = {
          pixelCullingThres: this.pixelCullingThres,
          specularMode: 0,
          dataServerUrl: this.playerServer
            ? this.playerServer
            : this.currentEnv.VUE_APP_STANDARD_SERVER || 'wp2ws.wizplant.online:9001',
          serverPro: this.playerServerProtocol
            ? this.playerServerProtocol
            : this.currentEnv.VUE_APP_STANDARD_SERVER || 'ws',
          skyBox: {
            url: '/static/img/skyBox',
            name: 'skybox_ocean',
          },
          fenceSource: '/static/img/fence',
          warningMark:
            this.playerBtnVisible.warningMark === undefined
              ? true
              : this.playerBtnVisible.warningMark,
          fence: this.playerBtnVisible.fence === undefined ? true : this.playerBtnVisible.fence,
          ground: this.playerBtnVisible.ground === undefined ? true : this.playerBtnVisible.ground,
          safeArea:
            this.playerBtnVisible.safeArea === undefined ? true : this.playerBtnVisible.safeArea,
          fault: this.playerBtnVisible.fault === undefined ? true : this.playerBtnVisible.fault,
          switches:
            this.playerBtnVisible.switches === undefined ? true : this.playerBtnVisible.switches,
          cameraPlay:
            this.playerBtnVisible.cameraPlay === undefined
              ? true
              : this.playerBtnVisible.cameraPlay,
        }
      }
    },
    imgAction() {
      this.$nextTick(() => {
        const $section = $('.focal')
        const $panzoom = $section.find('.panzoom').panzoom()
        $panzoom.parent().on('mousewheel.focal', (e) => {
          e.preventDefault()
          const delta = e.delta || e.originalEvent.wheelDelta
          const zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0
          $panzoom.panzoom('zoom', zoomOut, {
            animate: false,
            focal: e,
          })
        })
      })
    },
    async loadModelMethod(data) {
      if (data.fileId) {
        const identifierRes = await this.apiTags({
          method: 'tagIdentifier',
          params: {
            tagId: this.tagId,
            fileId: data.fileId,
          },
          extra: {
            errorMsg: false,
          },
        })
        if (identifierRes && identifierRes.data) {
          this.player.centerToSelect(this.currentSelectedFileId, identifierRes.data)
        }
      }
    },
    loadSvg(code, isCenter) {
      let svgDoc = null
      let timer = null
      svgDoc = document.getElementById('svgIframe').contentWindow.postMessage(code, '*')
      if (svgDoc === undefined && isCenter) {
        timer = setTimeout(() => {
          this.loadSvg(code)
        }, 300)
      } else {
        isCenter = false
        clearTimeout(timer)
        this.loadCallback(code)
      }
    },
    loadCallback(code) {
      setTimeout(() => {
        const iframeContainer = document.getElementById('iframeW')
        const list = {
          code,
          ifrWidth: iframeContainer.clientWidth,
          ifrHeight: iframeContainer.clientHeight,
        }
        document.getElementById('svgIframe').contentWindow.postMessage(list, '*')
      }, 20)
    },
    clickDocNode(data) {
      if (this.modelCenterVersion === 'v1') {
        this.wizPlayerAddModel(data)
      } else {
        this.docViewModel(data)
      }
    },
    // wizplayer加载
    async wizPlayerAddModel(data) {
      this.imgSrc = null
      const index = data.nodeName.lastIndexOf('.')
      if (data.nodeName && index >= 0) {
        this.type = data.nodeName.slice(index, data.nodeName.length)
        this.type = this.type.toLocaleLowerCase()
        this.fileValue = data.conentId
        this.currentSelectedFileId = data.fileId || null
        if (this.type === '.svg') {
          // 销毁player
          if (this.player) {
            this.player.destroy()
          }
          this.defaultFileData(this.type, this.fileValue)
          // const isCenter = true
          // setTimeout(() => {
          //   if (isCenter) {
          //     this.loadSvg(this.baseInfo.code, isCenter)
          //   }
          // }, 300)
          setTimeout(() => {
            window.postMessage(this.baseInfo.code, '*')
          }, 800)
        } else if (this.type === '.pr') {
          // player加载
          if (data.nodeType === 2) {
            this.$nextTick(async () => {
              if (this.player) {
                this.player.clearScene()
                this.player.loadScene(data.conentId, `${data.conentId}.pr`)
              } else {
                this.player = new Wizplayer.Player(
                  'container',
                  this.wizplayerOption,
                  async (code, res) => {
                    if (code === 1) {
                      // socket ready
                      this.player.loadScene(data.conentId, `${data.conentId}.pr`)
                    }
                    if (code === 2) {
                      // socket is failed or disconneted
                      console.warn('socket is failed or disconneted')
                    }
                    if (code === 3) {
                      // 初始化警示标注资源
                      this.player.warningMgr.addEventListener('init', () => {
                        const imgList = _.split(this.currentEnv.playerWarningImgs, ',')
                        _.forEach(imgList, (img) => {
                          this.player.warningMgr.addMarkImage(
                            `/static/img/warningmarker/${img.trim()}`
                          )
                        })
                      })
                      this.modelAlreadyLoaded = data.fileId
                      const identifierRes = await this.apiTags({
                        method: 'tagIdentifier',
                        params: {
                          tagId: this.tagId,
                          fileId: data.fileId,
                        },
                        extra: {
                          errorMsg: false,
                        },
                      })
                      this.centerToSelectImmediately = {
                        sceneId: this.currentSelectedFileId,
                        name: identifierRes.data,
                      }
                      if (this.centerToSelectImmediately) {
                        this.player.centerToSelect(
                          this.centerToSelectImmediately.sceneId,
                          this.centerToSelectImmediately.name
                        )
                      }
                    }
                    if (code === 4) {
                      // pickMgr select event is fired
                      this.selectInPlayer(res)
                    }
                  }
                )
              }
            })
          }
          this.modelLoad = false
          this.modelSrc = `../../../static/wizPlayer/index.html?file=${this.fileValue}.pr`
          this.loadModelMethod(this.baseInfo.code)
        } else {
          await this.defaultFileData(this.type, this.fileValue)
        }
      }
    },
    // 新版云渲染加载
    docViewModel(data) {
      this.currentBrowseFile = data
      this.imgSrc = null
      const index = data.nodeName.lastIndexOf('.')
      if (data.nodeName && index >= 0) {
        this.type = data.nodeName.slice(index, data.nodeName.length)
        this.type = this.type.toLocaleLowerCase()
        this.fileValue = data.conentId
        this.currentSelectedFileId = data.fileId || null
        if (this.type === '.pr') {
          this.$refs.fileView.mainFileType = 'pr'
          this.$refs.fileView.mainScreenFileName = data.nodeName
          this.$refs.fileView.playerId = data.fileId
          this.$refs.fileView.documentId = data.documentId
        } else {
          const resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.fileId}`
          const fileArr = data.nodeName.split('.')
          const fileType = fileArr.pop()
          this.$refs.fileView.mainFileType = fileType
          this.$refs.fileView.mainResourceUrl = resourceUrl
          this.$refs.fileView.mainScreenFileName =
            data.documentNodeName || `${data.nodeName}[${data.documentName}]`
          this.$refs.fileView.mainVersionTag = 0
          this.$refs.fileView.mainDocumentId = data.documentId
          this.$refs.fileView.mainFileId = data.fileId
          this.$refs.fileView.playerId = ''
          this.$refs.fileView.code = this.$route.query.title
        }
      }
    },
    async relativeTagRequest(siteIds, tagIds) {
      let param = null
      if (siteIds && tagIds) {
        param = {
          siteId: siteIds,
          tagId: tagIds,
        }
        const res = await this.apiTags({
          method: 'docRelationTag',
          params: param,
        })
        if (res && res.data && res.code === 0) {
          return res.data
        }
        return []
      }
      return []
    },
    async relationFileRequest(siteIds, tagCodes) {
      let param = null
      if (siteIds && tagCodes) {
        param = {
          siteId: siteIds,
          tagCode: tagCodes,
        }
        const res = await this.apiTags({
          method: 'docRelationFile',
          params: param,
        })
        if (res && res.data && res.code === 0) {
          return res.data
        }
        return []
      }
      return []
    },
    // 获取默认文件
    async defaultFileRequest(ids) {
      let param = null
      this.modelSrc = null
      if (ids) {
        param = {
          id: ids,
        }
        const res = await this.apiDefaultFile({
          method: 'defaultFile',
          params: param,
          extra: { errorMsg: false },
        })
        if (res && res.data && res.status === 200) {
          if (res.data && !_.isString(res.data)) {
            return '文件不存在'
          }
          if (this.type === '.wizdrawing') {
            return res.request.response
          }
          return res.request.responseURL
        }
        return ''
      }
      return []
    },
    async defaultFileData(type, id) {
      if (type === '.png' || type === '.jpg') {
        this.imgSrc = await this.defaultFileRequest(id)
        return this.imgAction()
      }
      if (type === '.mp4') {
        this.videoLoading = true
        const fileUrl = await this.defaultFileRequest(id)
        if (fileUrl) {
          this.playerOptions.sources[0].src = fileUrl
          this.videoError = false
        } else {
          this.videoError = true
        }
        this.videoLoading = false
      } else if (type === '.wizdrawing') {
        this.imgSrc = await this.defaultFileRequest(id)
        this.htLoad(this.imgSrc)
      } else {
        this.imgSrc = await this.defaultFileRequest(id)
      }
      return this.imgSrc
    },
    playerReadied(player) {
      player.currentTime(0)
    },
    screenfull() {
      const el = document.getElementById('staticBox')
      if (screenfull.enabled) {
        screenfull.request(el)
      }
    },
    // 跳转文档浏览
    async viewDocment(data) {
      if (data.documentId) {
        if (this.modelCenterVersion === 'v1') {
          // old version
          window.open(`/static/docBrowse/home.html?documentId=${data.documentId}`)
          return
        }
        const docBasicAttrRes = await DocumentService.findDocAttr({
          id: data.documentId,
          standardId: this.standardId,
        })
        const fileRes = await DocumentService.getDocumentFileType({
          fileId: docBasicAttrRes.data.defaultFileId,
          standardId: this.standardId,
          isVersion: false,
        })
        if (fileRes && fileRes.code === 0 && fileRes.data) {
          const fileNameType = _.split(fileRes.data.fileNameOrigin, '.')
          if (_.last(fileNameType) !== 'pr') {
            // 云渲染
            window.routerTrigger = 'noCache'
            this.$router.push({
              path: './doc-view',
              query: {
                documentId: data.documentId,
                title: encodeURIComponent(fileRes.data.fileNameOrigin),
                standardId: this.standardId,
                classId: this.classId,
              },
            })
          }
          if (_.last(fileNameType) === 'pr') {
            // 云渲染全屏版本
            window.routerTrigger = 'noCache'
            const routerData = this.$router.resolve({
              path: '/fullscreen/model-doc-view/index',
              query: {
                documentId: data.documentId,
                title: encodeURIComponent(fileRes.data.fileNameOrigin),
                standardId: this.standardId,
                classId: this.classId,
                token: localStorage.getItem('authorization'),
              },
            })
            window.open(routerData.href, '_blank')
          }
        } else {
          this.$message.error(fileRes.msg)
        }
      }
    },
    // 模型的交互
    modelLoaded() {
      // const _this = this
      if (document.getElementById('modelIframe')) {
        const player = document.getElementById('modelIframe').contentWindow
        player.pickMgr.event.addEventListener('select', (e) => {
          if (e && e.id && this.modelLoad) {
            this.interactiveFileData(this.currentProject.id, e.id, this.fileValue)
          }
        })
      }
    },
    svgLoaded() {
      if (!this.imgSrc) {
        return
      }
      const svgIframe = document.getElementById('svgIframe')
      if (svgIframe) {
        const offsetHeight = this.isScreen ? 730 : svgIframe.offsetHeight
        load('svgIframe', svgIframe.offsetWidth, offsetHeight)
        const postData = {
          code: this.baseInfo.code,
        }
        this.$nextTick(() => {
          svgIframe.contentWindow.postMessage(postData, '*')
        })
      }
    },
    async selectInPlayer(data) {
      this.interactiveFileData(this.currentProject.id, data.comID, this.defaultFileId)
    },
  },
  async created() {
    localforage.setItem('tagParamsId', this.$route.params.id || this.$route.query.id)
    this.imgSrc = null
    this.modelSrc = null
    await this.getTagId()
    await this.getTemplateAttribute()
    await this.initTimeLine()
    await this.initConnect()
    await this.initBaseInfo()
    await this.numTreeData()
    await this.documentTreeData()
    screenfull.on('change', () => {
      this.screenfullShow = screenfull.isFullscreen
    })
    this.wizplayerOption = {
      pixelCullingThres: this.pixelCullingThres,
      specularMode: 0,
      dataServerUrl: this.playerServer
        ? this.playerServer
        : this.currentEnv.VUE_APP_STANDARD_SERVER || 'wp2ws.wizplant.online:9001',
      serverPro: this.playerServerProtocol
        ? this.playerServerProtocol
        : this.currentEnv.VUE_APP_STANDARD_SERVER || 'ws',
      skyBox: {
        url: '/static/img/skyBox',
        name: 'skybox_ocean',
      },
      fenceSource: '/static/img/fence',
      warningMark:
        this.playerBtnVisible.warningMark === undefined ? true : this.playerBtnVisible.warningMark,
      fence: this.playerBtnVisible.fence === undefined ? true : this.playerBtnVisible.fence,
      ground: this.playerBtnVisible.ground === undefined ? true : this.playerBtnVisible.ground,
      safeArea:
        this.playerBtnVisible.safeArea === undefined ? true : this.playerBtnVisible.safeArea,
      fault: this.playerBtnVisible.fault === undefined ? true : this.playerBtnVisible.fault,
      switches:
        this.playerBtnVisible.switches === undefined ? true : this.playerBtnVisible.switches,
      cameraPlay:
        this.playerBtnVisible.cameraPlay === undefined ? true : this.playerBtnVisible.cameraPlay,
    }
  },
  activated() {
    const node = document.getElementById('EngineVideo')
    if (node) {
      node.play()
    }
  },
  destroyed() {
    if (this.player) {
      this.player.destroy()
    }
    this.baseInfoTabs = 'one'
    this.timeData = []
    this.tagId = ''
    screenfull.off('change')
  },
  mixins: [ApiMixins, ApiMixinTagObjectBrowse, apiCustomerMenu, ApiMixinCable],
}
</script>

<style scoped lang="scss" type="text/scss">

@import '~vis/dist/vis.css';
.object-tabs {
  height: 320px;
  .relation-tabs {
    height: 280px;
  }
}
// .el-card {
//   height: 522px;
// }
.screen-card {
  height: 800px;
}
.model-card {
  height: 816px;
}
.object-card {
  /deep/ .el-card__body {
    height: calc(100% - 50px);
  }
}
.fileView {
  height: 100% !important;

  /deep/.el-card__body {
    padding: 0px;
    height: 100%;
    // .player-tool {
    //   overflow-x: auto;
    //   .tool-tag {
    //     width: 1200px;
    //   }
    // }
  }
  /deep/ .model-file-name {
    font-size: 12px;
  }
}

</style>

<style lang="scss" type="text/scss" scoped>

.panel-inner {
  height: 228px;
  overflow-y: scroll;
}
.object-tabs {
  .el-tabs__content {
    height: 280px !important;
  }
}
.relation-tabs {
  .el-tabs__content {
    height: 192px !important;
  }
}
.object-card,
.screen-card {
  .el-card__body {
    height: 95%;
    #tabNetwork {
      height: 100%;
    }
  }
  .el-card__header {
    padding: 0px 20px;
    line-height: 40px;
  }
}
.connects {
  .el-card__body {
    padding: 5px;
  }
}
.switch-position {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 100;
}
.iframe-h {
  height: 800px;
}
.cover {
  object-fit: cover;
}
.object-card {
  #dommanager {
    width: 100% !important;
    height: 100% !important;
    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
.show-video {
  .video-js .vjs-big-play-button {
    top: 50% !important;
    left: 50% !important;
    margin-left: -43px;
    margin-top: -21px;
  }
}
#visualization {
  .vis-item {
    background-color: transparent;
    border: none;
    .vis-item-content {
      .circle-span {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        line-height: 20px;
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
      }
      .span-info {
        border: 2px solid #f56c6c;
        color: #f56c6c;
      }
      .span-check {
        border: 2px solid #67c23a;
        color: #67c23a;
      }
    }
  }
  .vis-item.vis-line {
    display: none;
  }
}
.doc-tree-lable {
  width: 80%;
}
.flex-row-between {
  display: flex;
  justify-content: space-between;
}
.text-overflow,
.ell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/deep/.el-card__header {
  padding: 10px 20px !important;
}

</style>
